// Device detection utilities
export const DeviceUtils = {
  isMobile(): boolean {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
           this.isMobileEmulation();
  },

  isMobileEmulation(): boolean {
    // Detect if we're in mobile emulation mode in developer tools
    return window.innerWidth <= 768 && 
           (navigator.userAgent.includes('Chrome') || navigator.userAgent.includes('Firefox')) &&
           !('ontouchstart' in window || navigator.maxTouchPoints > 0);
  },

  isIOS(): boolean {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
           (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 0);
  },

  isAndroid(): boolean {
    return /Android/i.test(navigator.userAgent);
  },

  isSafari(): boolean {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  },

  isIOSSafari(): boolean {
    return this.isIOS() && this.isSafari();
  },

  supportsDownload(): boolean {
    return 'download' in document.createElement('a');
  },

  supportsFileSystemAccess(): boolean {
    return 'showSaveFilePicker' in window;
  },

  getBrowserName(): string {
    const userAgent = navigator.userAgent;
    if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) return 'Chrome';
    if (userAgent.includes('Firefox')) return 'Firefox';
    if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) return 'Safari';
    if (userAgent.includes('Edg')) return 'Edge';
    return 'Unknown';
  },

  getDeviceInfo(): any {
    const userAgent = navigator.userAgent.toLowerCase();
    const platform = navigator.platform?.toLowerCase() || '';
    
    const isEmulatedMobile = this.isMobileEmulation();
    const isIOS = this.isIOS();
    const isAndroid = this.isAndroid();
    const isMobile = isIOS || isAndroid || 
                     /mobile|tablet|ipad|iphone|android/.test(userAgent) ||
                     isEmulatedMobile;
                     
    const isTablet = /ipad/.test(userAgent) || 
                     (isAndroid && !/mobile/.test(userAgent)) ||
                     (window.innerWidth >= 768 && window.innerWidth <= 1024 && isMobile);

    return {
      isMobile,
      isTablet,
      isIOS,
      isAndroid,
      isEmulatedMobile,
      isDesktop: !isMobile && !isTablet,
      userAgent,
      platform,
      supportsDownload: this.supportsDownload(),
      supportsFileAPI: this.supportsFileSystemAccess()
    };
  },

  getDownloadInstructions(): string {
    if (this.isIOSSafari()) {
      return 'PDF opened in new tab. To save:\n1. Tap the middle button (Share button) at the bottom\n2. Select "Save to Files"\n3. Choose your preferred folder location';
    }
    
    if (this.isAndroid()) {
      return 'If download didn\'t start automatically:\n1. Tap the menu (⋮) in your browser\n2. Select "Download" or "Downloads"\n3. The PDF will be saved to your Downloads folder';
    }

    if (this.isMobileEmulation()) {
      return 'In mobile emulation mode:\n1. Check your Downloads folder\n2. Or use browser\'s download menu to access the file';
    }
    
    return 'Use your browser\'s download or share options to save the file.';
  }
};
